import React, { useEffect, useCallback, useMemo } from 'react';
import { Flex } from 'antd';
import { Outlet } from 'react-router-dom';

import { ExportsControls } from '../components/ExportsControls';
import { ExportsProps } from '../interface/exports.interface';
import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../interfaces/common.interface';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { COMMON_FILTERS, FETCH_DELAY } from '../../../utils/common';
import { ExportsTable } from '../components/ExportsTable';
import { useAppSelector } from '../../../../../store';
import { useLazyReadExportsQuery } from '../service/exports.api';

export const ExportsContainer = () => {
    const {
        updateFilters,
        filters,
        get: fetchExport,
        source,
        loading,
    } = useFilters<CommonFiltersProps, ExportsProps>(
        useLazyReadExportsQuery,
        COMMON_FILTERS
    );

    const current = useAppSelector(selectShopCurrent);

    const payload = useMemo(
        () => ({
            ...filters,
            shop_id: current.id,
        }),
        [filters, current]
    );

    const refetch = useCallback(() => {
        fetchExport(payload, false);
    }, [fetchExport, payload]);

    const tableProps = useMemo<
        CommonTableProps<ExportsProps, CommonFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
        }),
        [loading, source, filters, updateFilters]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (current.id) {
                fetchExport(payload, true);
            }
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [fetchExport, payload, current]);

    return (
        <Flex gap={24} vertical>
            <ExportsControls loading={loading} onRefetch={refetch} />
            <ExportsTable {...tableProps} />
            <Outlet />
        </Flex>
    );
};
